// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"75e9144a","553":"f17bc716","746":"0b6fd9e5","977":"dd2b99e4"}[chunkId] + ".chunk.js";
};